module.exports = __webpack_public_path__ + "assets/img/prevArrow.cd760707.svg";